/** Money formatting shared by the customer pages.
 *
 * Every amount crossing the API is in cents, so these take cents and never a
 * pre-divided float — the division happens in exactly one place.
 */
export const money = (cents: number) =>
  `$${(cents / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

/** Rates below a cent read better as cents than as "$0.198". */
export const perMinute = (cents: number) =>
  cents < 100 ? `${Number(cents.toFixed(2))}¢` : money(cents);

/** A date-only string ("2026-08-30"), read as local rather than UTC midnight. */
export const onDate = (iso: string) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

/** The same, for a full timestamp — period bounds arrive with a time on them. */
export const onDay = (iso: string) =>
  new Date(iso).toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
